<script setup>
import { onMounted } from 'vue';

import { 
  kPage, 
  kBlockTitle,
  kPreloader,
  kBlock,
} from 'konsta/vue';

import { ClockIcon } from '@heroicons/vue/24/outline'

import {useBooking} from '@/stores/booking'
const bookingStore = useBooking();

import { useRoute } from 'vue-router';
const route = useRoute();

import {useConfig} from '@/stores/config'
const configStore = useConfig();

import StepNavigation from '@/components/StepNavigation.vue';
import SmartDateSelector from '@/components/SmartDateSelector.vue';
import MultiDate from '@/views/Step/MultiDate.vue';

import dateFn from '@/mixins/date'
import scrollTo from '@/mixins/scrollTo'

function remove_slot(index_to_remove){
  bookingStore.removeSlot(index_to_remove);
  
  setTimeout(_ => {
    bookingStore.track();
  }, 50);
}
function add_slot(index_to_add, slot_to_add){
  bookingStore.addSlot(index_to_add, slot_to_add);

  //scroll_to_last_slot_selected
  setTimeout(_ => {
    const selected_slots = document.querySelectorAll('#slots-container .slot.selected');
    const last_slot_selected = selected_slots[selected_slots.length-1];
    scrollTo.scrollToElem(last_slot_selected);
  }, 100);

  setTimeout(_ => {
    bookingStore.track();
  }, 50);
}

// aggiorna year/month nello store → il watch in booking.js rilancia _getSlotsbnb automaticamente
function onMonthChange({ year, month }) {
  bookingStore.bnb_view_year  = year
  bookingStore.bnb_view_month = month
}

// range completo selezionato: salva nel store e fa track
function onRangeSelected({ checkin, checkout }) {
  bookingStore.checkin  = checkin
  bookingStore.checkout = checkout
  bookingStore.track()
}

// prima chiamata disponibilità al mount (per il mese corrente)
onMounted(() => {
  if(configStore.config.layout === 'layout_b&b') bookingStore.getSlots()
})
</script>


<template>
  <template v-if="configStore.config.layout === 'layout_standard'">
    <div class="hidden md:block">
      <SmartDateSelector/>
    </div>

    <div v-if="bookingStore.loading_slots" class="text-center">
      <k-preloader />
    </div>
    <div v-else-if="!bookingStore.closed" id="slots-container" class="pb-10">
      <div v-for="b of bookingStore.blocks">
        <k-block-title>{{ b.name }}</k-block-title>
        <k-block>
          <div 
            :class="[
              'grid gap-4',
              'grid-cols-' + b.items_per_row
            ]">
            <a
              v-for="(s, index) in b.slots"
              :class="[
                'rounded-lg block border overflow-hidden',
                bookingStore.id_selected_block == b.id && bookingStore.slots_index_sequence.indexOf(index) != -1 ? 'border-primary bg-primary-light selected' : '',
                s.is_booked ? 'opacity-70' : '',
                !s.is_disabled && !s.is_booked && !(bookingStore.id_selected_block == b.id && bookingStore.slots_index_sequence.indexOf(index) != -1) ? 'bg-white' : '',
              ]"
              @click="_ => {
                if(s.is_booked) return;
                if(bookingStore.slots_index_sequence.indexOf(index) != -1){
                  remove_slot(index);
                }else{
                  add_slot(index, s);
                }
              }"
              >
              <div class="flex justify-between items-center border-b border-gray-300 px-2 pt-1 pb-1">
                <div class="flex items-center">
                  <ClockIcon class="w-3 h-3 mr-1"/>
                  {{ dateFn.get_duration_text(s.end - s.start + 1) }}
                </div>
                <div 
                  v-if="bookingStore.service_or_bundle.show_prices && s.price_with_tax && s.discount_percentage" 
                  class="bg-orange-500 text-white text-xs rounded-full px-2 leading-4">
                  -{{ s.discount_percentage }}%
                </div>
              </div>

              <div class="text-center px-2 pb-2">
                <div class="font-bold text-gray-600 pt-2 text-lg">
                  {{ dateFn.get_time_from_seconds(s.start) }} - {{ dateFn.get_time_from_seconds(s.end + 1) }}
                </div>
                <template v-if="bookingStore.service_or_bundle.show_prices && s.price_with_tax">
                  <div class="text-primary font-bold leading-none">
                    <template v-if="!s.is_disabled && !s.is_booked">{{ s.price_with_tax.toFixed(2) }} €</template>
                    <template v-else-if="s.is_disabled">Chiuso</template>
                    <template v-else-if="s.is_booked">Prenotato</template>
                  </div>
                  <div 
                    v-if="s.advised_price" 
                    class="italic line-through text-gray-600 leading-none">
                    {{ s.advised_price.toFixed(2) }} €
                  </div>
                </template>
                <div 
                  v-if="!bookingStore.service_bundle && bookingStore.service && bookingStore.service.show_availability"
                  class="mt-2 leading-none text-gray-500">
                  Disponibilità: <strong>{{s.places_available}} {{ s.places_available == 1 ? 'posto' : 'posti' }}</strong>
                </div>
              </div>
            </a>
          </div>
        </k-block>
      </div>
    </div>
    <div v-if="bookingStore.closed" class="text-gray-600 pt-10 text-center">
      {{ bookingStore.closed.message }}
    </div>
  </template>

  <template v-if="configStore.config.layout === 'layout_b&b'">
    <MultiDate
      :availability="bookingStore.bnb_availability"
      :loading="bookingStore.loading_slots"
      @update:checkin="val => bookingStore.checkin = val"
      @update:checkout="val => bookingStore.checkout = val"
      @range-selected="onRangeSelected"
      @month-change="onMonthChange"
    />
  </template>

  <StepNavigation/>

</template>

<style lang="scss">

</style>